import {ErrorState} from 'components/ErrorState';
import {ComponentProps} from 'react';
import {ErrorBoundary} from '../ErrorBoundary';

export function PageErrorBoundary({children, FallbackComponent, ...props}: ComponentProps<typeof ErrorBoundary>) {
    return (
        <ErrorBoundary
            {...props}
            FallbackComponent={(fallbackProps) =>
                FallbackComponent ? (
                    <FallbackComponent {...fallbackProps} />
                ) : (
                    <ErrorState onRetry={fallbackProps.resetErrorBoundary} />
                )
            }
        >
            {children}
        </ErrorBoundary>
    );
}
